// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IFraudReviewRequestDto
 */
export interface IFraudReviewRequestDto {
    /**
     * 
     * @type {boolean}
     * @memberof IFraudReviewRequestDto
     */
    is_fraud_review_required: boolean;
}

/**
 * Check if a given object implements the IFraudReviewRequestDto interface.
 */
export function instanceOfIFraudReviewRequestDto(value: object): value is IFraudReviewRequestDto {
    if (!('is_fraud_review_required' in value) || value['is_fraud_review_required'] === undefined) return false;
    return true;
}

export function IFraudReviewRequestDtoFromJSON(json: any): IFraudReviewRequestDto {
    return IFraudReviewRequestDtoFromJSONTyped(json, false);
}

export function IFraudReviewRequestDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IFraudReviewRequestDto {
    if (json == null) {
        return json;
    }
    return {
        
        'is_fraud_review_required': json['is_fraud_review_required'],
    };
}

export function IFraudReviewRequestDtoToJSON(json: any): IFraudReviewRequestDto {
    return IFraudReviewRequestDtoToJSONTyped(json, false);
}

export function IFraudReviewRequestDtoToJSONTyped(value?: IFraudReviewRequestDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'is_fraud_review_required': value['is_fraud_review_required'],
    };
}

